import styled from '@emotion/styled'

import { NewShift } from './NewShift'
import { Color, theme } from '../../../../constants'
import { Clickable, Icon } from '../../../../elements'
import { UIShift } from '../types'

const Button = styled(Clickable)`
  border-radius: ${theme.border.radius.normal}px;
  width: 100%;
  min-height: 22px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};

  svg {
    color: ${Color.TRANSPARENT};
  }

  :hover {
    background: ${Color.LIGHTEST_BLUE};
    opacity: 50%;
    svg {
      color: ${Color.BLACK};
      opacity: 0.65;
    }
  }
`

type DraftShiftsProps = {
  showBadges?: boolean
  onClickNewShift?: () => void
  onClickShift?: (shiftId: string) => void
  onDeleteDraftShift: (shiftId: string) => void
  shifts: UIShift[]
}

export const DraftShifts = (props: DraftShiftsProps) => {
  return (
    <>
      {props.onClickNewShift && (
        <Button onClick={props.onClickNewShift}>
          <Icon name="PlusIcon" size="md" />
        </Button>
      )}
      {props.shifts.map((shift, i) => (
        <NewShift
          key={i}
          shiftIds={[shift.id]}
          shift={shift}
          onDelete={() => props.onDeleteDraftShift(shift.id)}
          onClick={
            props.onClickShift
              ? () => props.onClickShift?.(shift.id)
              : undefined
          }
          status="DRAFT"
          unselectable
        />
      ))}
    </>
  )
}
